export const SET_ERROR = 'PCFitmentManager/SET_ERROR';
export const CLEAR_ERROR = 'PCFitmentManager/CLEAR_ERROR';

export const FETCH_ACCOUNT_REQUEST = 'PCFitmentManager/FETCH_ACCOUNT_REQUEST';
export const FETCH_ACCOUNT_SUCCESS = 'PCFitmentManager/FETCH_ACCOUNT_SUCCESS';
export const FETCH_ACCOUNT_FAILURE = 'PCFitmentManager/FETCH_ACCOUNT_FAILURE';
